import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GeoMap } from './GeoMap.js';
import { GoogleMap } from './GoogleMap.js';
import { resolveMapsKey } from './googleMapsLogic.js';
import { MapUnavailableNotice } from './MapUnavailableNotice.js';
export function WorkforceMap({ mapsApiKey, ...geoProps }) {
    const key = resolveMapsKey({ VITE_GOOGLE_MAPS_API_KEY: mapsApiKey });
    if (!key) {
        return (_jsxs("div", { children: [_jsx(MapUnavailableNotice, { reason: "no-key" }), _jsx(GeoMap, { ...geoProps })] }));
    }
    return _jsx(GoogleMap, { ...geoProps, mapsApiKey: key });
}
//# sourceMappingURL=WorkforceMap.js.map